import {IntermediatePart} from "../../intermediatePart";
import {Vanity} from "../../parts/vanity";

export default class Mirror extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'vanity_mirror';
    this.partName = 'Mirror';
    this.translateId = "visualizer.bathroom.vanity.vanity_mirror";
    this.homePageTitle = 'Mirrors';
    this.visible = [Vanity.Types.Complete, Vanity.Types.Custom];
    this.canBeDisabled = false;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new Mirror())
  }

  setZIndex(zIndexes) {
    // if ((this.getParent().activeSubType_ === Vanity.Types.Custom) && this.activeFeature) {
    if (zIndexes && this.activeFeature) {
      // this.activeFeature.layer.zIndex = Z.layouts.Large.Vanity.Mirror;
      this.activeFeature.layer.zIndex = zIndexes.Vanity.Mirror;
    }
  }
}
